<template>
    <CRUDList ref="crudList"
      noResultOverride="No payments found"
     :canAdd="false"
     :canEdit="false"
     :canSave="true"
     :selectedItems="selectedItems"
     :showSelect="false"
     :displayTopPagination="false"
     :hideDefaultFooter="true"
     :enableFixedHeaders="true"
     :disableKeyboardFunc="false"
     :headers="headers"
     :baseCrudKey="baseCrudKey"
     :defaultSortBy="defaultSortBy"
     :uploadFileParams="uploadFileParams"
     :variableToChangeRowBgColor="[{ varName: 'posted', varCol: '#ffe5006b' }]"
     tableWrapperDynamicClassname='taxroll-table-wrapper-two'
     :tableDynamicHeight="getHeight"
     @emitSelectedItem="emitSelectedItem"
     :loadingData="gridLoading.flag"
     :loadingText="gridLoading.text">
    </CRUDList>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import CRUDList from '../../../../common/base/crud-2.0/CRUDList.vue';
import { paymentsRecordsHeaders } from '../../TaxInquiryUtils/TableHeaders.utils';
import { defaultGridLoading, manageGridLoading } from '../../../../../util/shared/vue-global';
import '../../../../../assets/style.css';

export default {
  name: 'TaxRollPayments',
  components: {
    CRUDList,
  },
  data() {
    return {
      baseCrudKey: 'paymentsRecords',
      headers: this.buildHeaders(),
      gridLoading: defaultGridLoading(),
      uploadFileParams: {
        bucketName: 'taxPayment',
        program: 'taxPayment',
        parentObjectType: 'taxPayments',
      },
    };
  },
  props: {
    getHeight: {
      type: String,
      default: '190',
    },
    selItem: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState({
      StoreSelItems: (state) => state.tax.taxInquires.selectedPamentsRecords,
      paymentSettingItem: (state) => state.SystemConfig.paymentSettingItem,
    }),
    selectedItems: {
      get() {
        return this.StoreSelItems;
      },
      set(value) {
        this.setSelectedPamentsRecords(value);
      },
    },
    defaultSortBy() {
      return [
        {
          column: 'name',
          direction: 'desc',
        },
      ];
    },
  },
  methods: {
    manageGridLoading,
    ...mapMutations('tax/taxInquires', [
      'setSelectedPamentsRecords',
    ]),
    buildHeaders(showReceipt) {
      const useReceipt = showReceipt !== undefined
        ? showReceipt
        : ((this.paymentSettingItem || {}).showReceiptNumberOnPaymentScreen || false);
      return paymentsRecordsHeaders.map((h) => {
        if (h.value === 'payment') {
          return useReceipt
            ? { ...h, text: 'Receipt #', value: 'reciept' }
            : h;
        }
        return h;
      });
    },
    emitSelectedItem(id) {
      this.selectedItems = id;
    },
  },
  watch: {
    'paymentSettingItem.showReceiptNumberOnPaymentScreen': {
      handler(val) {
        this.headers = this.buildHeaders(val);
      },
      immediate: true,
    },
  },
};
</script>
